(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["headerv2"]) return;
  try {
    
  let closeModalTimer;
  let closeMiniCartTimer;

  document.addEventListener('DOMContentLoaded', () => {
    // Custom event trigger when cart is updated
    document.addEventListener('cart:update', (event) => {
      if (document.querySelector('[data-rebranding-drawer]')) return;
      if (event.detail.data.source === 'product-form-component' || event.detail.data.source === 'wish-list-product-card') {
        if (event.detail.data.didError) return;
        // Get product data from the cart update event
        const productId = event.detail.data.productId;
        const productHandle = event.detail.data.productHandle;
        const variantId = event.detail.sourceId; // This is the variant ID from formData.get("id")
        const cartData = event.detail.cart;

        // Use product handle from event data if available
        if (productHandle) {
          showAddedToCartModal(productHandle, variantId);
        } else {
          // Fallback: try to get from cart data or current page
          const fallbackHandle = getFallbackProductHandle(productId, cartData);
          showAddedToCartModal(fallbackHandle, variantId);
        }
        refreshHeaderSection();
      }
    });

    document.addEventListener('wishlist:update', (event) => {
      const { wishlist } = event.detail;
      
      showAddedToWishlistModal(wishlist.productHandle, wishlist.variantId);
    });
  });

  // Function to open the mini cart for a few seconds
  function openMiniCart() {
    const cartIconGroup = document.querySelector('#cart-icon-group');
    if (!cartIconGroup) return;

    cartIconGroup.classList.add('is-open');

    clearTimeout(closeMiniCartTimer);
    closeMiniCartTimer = setTimeout(() => {
      cartIconGroup.classList.remove('is-open');
    }, 5000);
  }

  // Function to refresh only the cart dropdown using Shopify's section rendering API
  function refreshHeaderSection() {
    const cartDropdown = document.querySelector('#cart-dropdown');
    const cartCounter = document.querySelectorAll('.header__cart-counter');
    if (!cartDropdown) return;

    //refresh the timers
    clearTimeout(closeModalTimer);
    clearTimeout(closeMiniCartTimer);

    fetch(`${window.location.pathname}?section_id=headerv2`)
      .then((response) => response.text())
      .then((html) => {
        // Create a temporary container to parse the response
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Find the cart dropdown in the response
        const newCartDropdown = tempDiv.querySelector('#cart-dropdown');
        if (newCartDropdown) {
          cartDropdown.closest('#cart-icon-group')?.setAttribute('data-cart-state', newCartDropdown.closest('#cart-icon-group')?.getAttribute('data-cart-state'));
          // Replace the current cart dropdown with the updated one
          cartDropdown.replaceWith(newCartDropdown);
        }

        // Update cart counters (mobile and desktop)
        const newCartCounters = tempDiv.querySelectorAll('.header__cart-counter');
        newCartCounters.forEach((newCounter) => {
        });
        cartCounter.forEach((counter, index) => {
          if (newCartCounters[index]) {
            counter.replaceWith(newCartCounters[index]);
          } else {
            // Remove counter if cart is empty
            counter.remove();
          }
        });
      })
      .catch((error) => {
        console.error('Error refreshing cart dropdown:', error);
        // Fallback to page reload if section rendering fails
        window.location.reload();
      });
  }

  // Function to remove cart item and trigger cart update
  function removeCartItem(itemKey) {
    const formData = new FormData();
    formData.append('id', itemKey);
    formData.append('quantity', '0');

    fetch('/cart/change.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // Trigger the custom cart update event
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            detail: { cart: data },
          })
        );
      })
      .catch((error) => {
        console.error('Error removing item from cart:', error);
      });
  }

  // Function to show the added to cart modal
  function showAddedToCartModal(productIdentifier = null, variantId = null) {
    const modal = document.querySelector('#added-to-cart-modal');
    if (!modal) return;

    // Load product content via Shopify section rendering if product identifier is provided
    if (productIdentifier) {
      loadCartNotificationProduct(productIdentifier, variantId);
    } else {
      // Show basic notification if no product identifier found
      showBasicNotification();
    }
  }

  // Function to show the added to wishlist modal
  function showAddedToWishlistModal(productIdentifier = null, variantId = null) {
    // const modal = document.querySelector('#added-to-wishlist-modal');
    // if (!modal) return;

    console.log('Show added to wishlist modal', productIdentifier);

    // Load product content via Shopify section rendering if product identifier is provided
    if (!productIdentifier || !variantId) return;


    loadCartNotificationProduct(productIdentifier, variantId, 'wishlist');
  }

  // Function to show the modal with proper timing
  function showModal(type) {
    const modal = document.querySelector('#added-to-cart-modal');
    const overlay = document.querySelector('#added-to-cart-overlay');
    const article = document.querySelector('article[data-product-notification-card]');
    if (!modal) {
      console.error('Modal not found');
      return;
    }

    clearTimeout(closeMiniCartTimer);
    clearTimeout(closeModalTimer);

    // Show overlay + modal
    if (overlay) {
      overlay.classList.remove('opacity-0', 'invisible');
      overlay.classList.add('opacity-100', 'visible');
    }
    modal.classList.remove('opacity-0', 'invisible');
    modal.classList.add('opacity-100', 'visible');
    document.body.classList.add('body-notification-overlay');

    if (article) {
      article.setAttribute('type', type === 'wishlist' ? 'wishlist' : 'cart');
    }
  }

  // Function to close the added to cart modal
  function closeAddedToCartModal() {
    clearTimeout(closeModalTimer);
    document.body.classList.remove('body-notification-overlay');
    const modal = document.querySelector('#added-to-cart-modal');
    const overlay = document.querySelector('#added-to-cart-overlay');
    if (modal) {
      modal.classList.remove('opacity-100', 'visible');
      modal.classList.add('opacity-0', 'invisible');
    }
    if (overlay) {
      overlay.classList.remove('opacity-100', 'visible');
      overlay.classList.add('opacity-0', 'invisible');
    }
  }

  // Expose to global scope so inline onclick handlers can call it
  window.closeAddedToCartModal = closeAddedToCartModal;

  // Function to load cart notification product via Shopify section rendering
  function loadCartNotificationProduct(productIdentifier, variantId = null, type = 'cart') {
    const contentContainer = document.querySelector('#cart-notification-content');
    if (!contentContainer) return;

    // Show loading state
    contentContainer.innerHTML = `
      <div class="flex flex-col md:flex-row md:min-h-[320px]">
        <div class="w-full h-[220px] md:w-1/2 md:h-auto bg-gray-100 shimmer"></div>
        <div class="w-full md:w-1/2 p-6 flex flex-col justify-center gap-3">
          <div class="h-5 w-2/3 bg-gray-200 shimmer rounded"></div>
          <div class="h-4 w-full bg-gray-200 shimmer rounded"></div>
          <div class="h-4 w-4/5 bg-gray-200 shimmer rounded"></div>
          <div class="h-12 w-full bg-gray-100 shimmer rounded-full mt-3"></div>
          <div class="h-12 w-full bg-gray-200 shimmer rounded-full"></div>
        </div>
      </div>
    `;

    // Check if we have a product handle or need to find one
    if (isProductHandle(productIdentifier)) {
      loadProductNotificationByHandle(productIdentifier, variantId, type);
    } else {
      getProductHandleAndLoadNotification(productIdentifier, variantId);
    }
  }

  // Function to check if a string is a product handle
  function isProductHandle(identifier) {
    // Product handles typically contain letters and hyphens, not just numbers
    // They also don't start with numbers usually
    return (
      typeof identifier === 'string' &&
      identifier.length > 0 &&
      !/^\d+$/.test(identifier) &&
      !identifier.includes('product-')
    );
  }

  // Function to get fallback product handle from various sources
  function getFallbackProductHandle(productId, cartData) {
    // Try to get from cart data first
    if (cartData && cartData.items && cartData.items.length > 0) {
      const latestItem = cartData.items[cartData.items.length - 1];
      if (latestItem && latestItem.product_handle) {
        return latestItem.product_handle;
      }
    }

    // Try to get from current page URL
    const currentProductHandle = getCurrentProductHandle();
    if (currentProductHandle) {
      return currentProductHandle;
    }

    // If all else fails, return null to show basic notification
    return null;
  }

  // Function to get product handle and load notification
  function getProductHandleAndLoadNotification(productId, variantId = null) {
    // First, try to get the product handle from the current page if we're on a product page
    const currentProductHandle = getCurrentProductHandle();

    if (currentProductHandle) {
      loadProductNotificationByHandle(currentProductHandle, variantId);
    } else {
      // Fallback: try to get from cart data or show basic notification
      showBasicNotification();
    }
  }

  // Function to get current product handle from URL
  function getCurrentProductHandle() {
    const path = window.location.pathname;
    const productMatch = path.match(/\/products\/([^\/\?]+)/);
    if (productMatch) {
      return productMatch[1];
    }
    return null;
  }

  // Function to load product notification by handle
  function loadProductNotificationByHandle(productHandle, variantId = null, type = 'cart') {
    const contentContainer = document.querySelector('#cart-notification-content');
    if (!contentContainer) return;

    // Build URL with variant parameter if available
    let url = `/products/${productHandle}?view=notification-card`;
    if (variantId) {
      url += `&variant=${variantId}`;
    }

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        // Create a temporary container to parse the response
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Find the cart notification product content
        const productContent = tempDiv.querySelector('.product-notification-card');

        if (productContent) {
          // Replace the loading content with the actual product content
          contentContainer.innerHTML = '';
          contentContainer.appendChild(productContent);

          // Show modal with product card UI after successful loading
          showModal(type);
        } else {
          showBasicNotification();
        }
      })
      .catch((error) => {
        console.error('Error loading cart notification product:', error);
        showBasicNotification();
      });
  }

  // Function to show basic notification
  function showBasicNotification() {
    const contentContainer = document.querySelector('#cart-notification-content');
    if (!contentContainer) return;

    contentContainer.innerHTML = `
      <div class="flex flex-col md:flex-row md:min-h-[320px]">
        <div class="w-full h-[220px] md:w-1/2 md:h-auto bg-gray-100"></div>
        <div class="w-full md:w-1/2 flex flex-col justify-center px-6 py-7 relative">
          <button onclick="closeAddedToCartModal()" class="absolute top-4 right-4 w-7 h-7 flex items-center justify-center hover:opacity-50 transition-opacity" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1L13 13M13 1L1 13" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="mb-6 mt-4 md:mt-0">
            <p class="font-bold text-[15px] uppercase tracking-wide mb-1">PRODUCT(S)</p>
            <p class="text-[13px] text-gray-500 leading-snug">successfully added to your shopping bag!</p>
          </div>
          <div class="flex flex-col gap-3 pb-2">
            <button onclick="closeAddedToCartModal()" class="w-full h-12 border border-black rounded-full text-[11px] font-semibold uppercase tracking-widest bg-white hover:bg-gray-50 transition-colors">CONTINUE SHOPPING</button>
            <a href="/cart" class="w-full h-12 bg-[#1c1c1c] text-white rounded-full text-[11px] font-semibold uppercase tracking-widest flex items-center justify-center hover:bg-black transition-colors">CHECKOUT</a>
          </div>
        </div>
      </div>
    `;
    showModal();
  }

  // Close modal when clicking the overlay
  document.addEventListener('click', (event) => {
    const overlay = document.querySelector('#added-to-cart-overlay');
    if (overlay && event.target === overlay) {
      closeAddedToCartModal();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const newsletterSection = document.getElementById('newsletter-form-v2');
    if (!newsletterSection) return;

    const newsletterInput = newsletterSection.querySelector('#NewsletterInput');
    const newsletterActions = newsletterSection.querySelector('#NewsletterActions');
    const newsletterSubmit = newsletterSection.querySelector('#NewsletterSubmit');
    const privacyConsent = newsletterSection.querySelector('#newsletter-consent-3');
    const form = newsletterSection.querySelector('form');

    if (newsletterInput && newsletterActions) {
      newsletterInput.addEventListener(
        'focus',
        function () {
          newsletterActions.classList.add('is-focused');
          newsletterActions.classList.remove('hidden');
        },
        { once: true }
      );
    }

    let checkConsents = () => {}; // Define in a broader scope

    if (newsletterInput) {
      newsletterInput.addEventListener('input', function () {
        if (validateEmail(newsletterInput.value)) {
          newsletterSection.removeAttribute('data-error');
        }
        // Re-check conditions for enabling the button on every input
        if (typeof checkConsents === 'function') {
          checkConsents();
        }
      });
    }

    if (privacyConsent && newsletterSubmit && newsletterInput) {
      checkConsents = () => {
        if (privacyConsent.checked && newsletterInput.value.trim() !== '') {
          newsletterSubmit.disabled = false;
        } else {
          newsletterSubmit.disabled = true;
        }
      };

      privacyConsent.addEventListener('change', checkConsents);
      // Initial check in case of pre-filled forms
      checkConsents();
    }

    if (form) {
      newsletterSubmit.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const formWrapper = form.closest('[data-form-wrapper]');
        
        const email = newsletterInput.value;
        if (!validateEmail(email)) {
          newsletterSection.setAttribute('data-error', '');
          return;
        }

        newsletterSection.removeAttribute('data-error');
        newsletterSection.removeAttribute('data-error-server');
        
        const formData = new FormData(form);
        const config = {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: `application/javascript`,
          },
        };

        fetch('/contact', config)
          .then((response) => {
            if (!response.ok) {
              newsletterSection.setAttribute('data-error-server', 'true');

              return;
            }
            return response.text();
          })
          .then((text) => {
            const newSection = new DOMParser()
              .parseFromString(text, 'text/html')
              .getElementById(`newsletter-form-v2`);
            if (newSection) {
              newsletterSection.innerHTML = newSection.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
            newsletterSection.setAttribute('data-error-server', 'true');
          });
      });
    }

    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-template"]) return;
  try {
    
  //Search Clear Button
  document.getElementById('searchClearButton').addEventListener('click', () => {
    const searchInput = document.querySelector('#SearchForm input[type="search"]');
    searchInput.value = '';
    searchInput.focus();
  });

  } catch(e) { console.error(e); }
})();
})();
